import { render, staticRenderFns } from "./SEntrega99Info.vue?vue&type=template&id=74f3f777"
import script from "./SEntrega99Info.vue?vue&type=script&lang=js"
export * from "./SEntrega99Info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports